import React, { useEffect, useRef, useState } from 'react';
import SelectSearch from "react-select";
import "../../assets/styles/Search.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js"
import { config } from "../../config.js";
import { apiCheckDataAccount, apiFormUpdateAccount, apiGetRequestHistory, apiGetBanks } from "../../services/api.service.js";
import {
  Box,
  Button,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconImage from "../../icons/icon-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingCount, setPollingCount] = useState(0);
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");
  const pollingCountRef = useRef(0);
  const isCheckingRequestRef = useRef(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
    bank_type_change: "",
    full_name_bank: "",
    wallet_name: "",
    wallet_number: "",
    password: "",
  };
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_code: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  
  
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const inputDataCheck = (event) => {
    let { name, value } = event.target;
    if(name === "phone_number") {
      value = value.replace(/^(\+?84)/, "0");
    }
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };
  
  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
  };
  let contentUpdate;
  const [banks, setBanks] = useState([]); // danh sách ngân hàng cho khách chọn: [{ code, name }]
  // nhãn ngân hàng mới theo loại yêu cầu đổi ngân hàng
  const bankFieldSuffix = dataUpdate.bank_type_change === "Xóa số tài khoản" ? "Cần Xóa" : "Mới";

  // mô tả file upload và số ảnh tối thiểu theo mục thông tin khách đang chọn (setup ở admin)
  const uploadSetting = webSetting?.upload_descriptions || {};
  const uploadConfig = uploadSetting.by_update_type?.[typeModal] || {};
  const uploadDescriptions = [];
  (uploadConfig.keys || []).forEach((key) => {
    const item = (uploadSetting.items || []).find((item) => item.key === key);
    if (item?.content) uploadDescriptions.push(item.content);
  });
  const minFiles = uploadConfig.min_files ?? 2; // chưa setup thì mặc định 2 ảnh

  // xác nhận hoàn thành không cần xác thực: đổi ngày sinh, hoặc quên mật khẩu khi tài khoản không có email / sđt / stk
  const canAutoConfirm = typeModal === "birthday" ||
    (typeModal === "forget_password" && !data?.email && !data?.phone_number && !data?.bank_number);

  useEffect(() => {
    updateUserField("update_type", typeModal)
  }, [typeModal]);

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  // chọn ngân hàng: lưu cả mã ngân hàng và tên ngân hàng
  const selectBankCheck = (option) => {
    const bank = banks.find((item) => item.code === option?.value);
    setDataCheck({ ...dataCheck, bank_code: bank ? bank.code : "", bank_name: bank ? bank.name : "" });
  };
  const selectBankUpdate = (option) => {
    const bank = banks.find((item) => item.code === option?.value);
    setDataUpdate({ ...dataUpdate, bank_code: bank ? bank.code : "", bank_name: bank ? bank.name : "" });
  };

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingCount >= 15) {
      return undefined;
    }

    const checkStatus = async () => {
      if (isCheckingRequestRef.current || pollingCountRef.current >= 15) return;
      isCheckingRequestRef.current = true;
      const result = await apiGetRequestHistory(user.account, submittedRequest.request_code);
      isCheckingRequestRef.current = false;
      pollingCountRef.current += 1;
      setPollingCount(pollingCountRef.current);

      if (result?.code === 200 && result?.data?.request) {
        const request = result.data.request;
        setSubmittedRequest(request);
        setRecentRequests((items) => items.map((item) => (item._request_code || item.request_code) === request.request_code
          ? { ...request, _request_code: request.request_code, request_code: `xxxxx${request.request_code.slice(-3)}` }
          : item).slice(0, 2));
      }
    };

    const intervalId = setInterval(checkStatus, 30 * 1000);
    return () => clearInterval(intervalId);
  }, [openConfirm, pollingCount, submittedRequest?.request_code, submittedRequest?.status, user.account]);

  const validateForm = (type = false, checkData = dataCheck) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!checkData.name) {
      formIsValid = false;
      errors.name = 'Vui lòng nhập Họ và Tên';
    }

    // Kiểm tra trường phone_number // khi thay đổi ngày tháng năm sinh không cần nhập thông tin sđt cũ
    if (data.phone_number && type === "phone_number") {
      if (!checkData.phone_number) {
        formIsValid = false;
        errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
      } else if (!/^\d{10}$/.test(checkData.phone_number)) {
        formIsValid = false;
        errors.phone_number = 'Số Điện Thoại không hợp lệ';
      }
    }

    // Kiểm tra trường email // khi thay đổi ngày tháng năm sinh không cần nhập thông tin email cũ
    if (data.email && type === "mail") {
      if (!checkData.email) {
        formIsValid = false;
        errors.email = 'Vui lòng nhập Email';
      } else if (!/\S+@\S+\.\S+/.test(checkData.email)) {
        formIsValid = false;
        errors.email = 'Email không hợp lệ';
      }
    }

    // Trường Ngân Hàng chỉ hiển thị, không cần validate
    if (!checkData.bank_name) {
      formIsValid = false;
      errors.bank_name = 'Vui lòng chọn Ngân Hàng';
    }

    // Kiểm tra trường bank_number
    if (!checkData.bank_number) {
      formIsValid = false;
      errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
      if (!dataUpdate.name) {
        formIsValid = false;
        errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
      } else {
        contentUpdate = dataUpdate.name;
      }
      break;
      case "phone_number":// Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email":// Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = 'Vui lòng nhập Email mới';
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = 'Email mới không hợp lệ';
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank":// Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = `Vui lòng chọn Ngân Hàng ${bankFieldSuffix}`;
        }
        if (!dataUpdate.full_name_bank) {
          formIsValid = false;
          errors.full_name_bank = 'Vui lòng nhập chi nhánh Ngân Hàng mới';
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = `Vui lòng nhập Số Tài Khoản ${bankFieldSuffix}`;
        } else {
          contentUpdate = (dataUpdate.bank_type_change + " - " + dataUpdate.bank_number + " - " + dataUpdate.bank_name + " - " + dataUpdate.full_name_bank)
        }
        break;
      case "birthday": // Kiểm tra trường birth day
        if (!dataUpdate.birth_day) {
          formIsValid = false;
          errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
        } else {
          contentUpdate = dataUpdate.birth_day;
        }
        break;
      case "usdt": // Kiểm tra trường USDT
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = 'Vui lòng chọn yêu cầu thay đổi';
        }
        if (!dataUpdate.wallet_name) {
          formIsValid = false;
          errors.walletName = 'Vui lòng chọn Ví Mới';
        }
        if (!dataUpdate.wallet_number) {
          formIsValid = false;
          errors.walletNumber = 'Vui lòng nhập Số Ví USDT Mới';
        } else {
          contentUpdate = (dataUpdate.bank_type_change + " - " + dataUpdate.wallet_name + " - " + dataUpdate.wallet_number);
        }
        break;
      default: break
    }
    console.log(errors)
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = async (type, checkData = dataCheck) => {
    if (type === "files" || (type === "auto_confirm" && canAutoConfirm)) {
      if (validateForm(type, checkData)) updateUser(type, checkData);
      return;
    }

    if (!validateForm("files", checkData)) return;

    const isEmail = type === "mail";
    const result = await Swal.fire({
      icon: "warning",
      title: isEmail ? "Vui lòng nhập Email đã liên kết" : "Vui lòng nhập Số Điện Thoại đã liên kết",
      input: isEmail ? "email" : "text",
      inputValue: isEmail ? checkData.email : checkData.phone_number,
      inputPlaceholder: isEmail ? "Email đã liên kết" : "Số Điện Thoại đã liên kết",
      showCancelButton: true,
      confirmButtonText: "Tiếp tục",
      cancelButtonText: "Quay lại",
      reverseButtons: true,
      inputValidator: (value) => {
        const normalizedValue = isEmail
          ? value.trim().toLowerCase()
          : value.trim().replace(/^(\+?84)/, "0");
        if (!normalizedValue) return isEmail ? "Vui lòng nhập Email" : "Vui lòng nhập Số Điện Thoại";
        if (isEmail && !/\S+@\S+\.\S+/.test(normalizedValue)) return "Email không hợp lệ";
        if (!isEmail && !/^\d{10}$/.test(normalizedValue)) return "Số Điện Thoại không hợp lệ";
        return undefined;
      },
    });

    if (result.isConfirmed) {
      const value = isEmail
        ? result.value.trim().toLowerCase()
        : result.value.trim().replace(/^(\+?84)/, "0");
      const nextDataCheck = { ...checkData, [isEmail ? "email" : "phone_number"]: value };
      setDataCheck(nextDataCheck);
      updateUser(type, nextDataCheck);
    }
  };
  
  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };
  
  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true)
    let updateInfo = await apiFormUpdateAccount(body, type === "auto_confirm" ? [] : selectedFiles);
    setLoading(false)
    if (updateInfo?.request_code) {
      updateUserField("request_code", updateInfo.request_code);
      const newRequest = {
        _request_code: updateInfo.request_code,
        request_code: `xxxxx${updateInfo.request_code.slice(-3)}`,
        update_type: body.update_type,
        send_type: body.send_type,
        status: "no_process",
        verification_status: ["email", "phone_number"].includes(body.send_type) ? "not_received" : "success",
      };
      setRecentRequests((items) => [newRequest, ...items].slice(0, 2));
      setSubmittedRequest({ ...newRequest, request_code: updateInfo.request_code, note: "" });
      pollingCountRef.current = 0;
      setPollingCount(0);
      setRequestRefreshMessage("");
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, checkData = dataCheck) => {
    if (validateForm(type, checkData)) {
      if (type === "mail") {
        user.send_type = 'email';
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = 'phone_number';
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = 'files';
        updateUserField('send_type', 'files')
        setIsSendMail(false);
      } else if (type === "auto_confirm" && canAutoConfirm) {
        user.send_type = 'auto_confirm';
        updateUserField('send_type', 'auto_confirm')
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...checkData,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
          // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản để BE không phải tách từ content
          ...(user.update_type === "bank" && {
            bank_code: dataUpdate.bank_code,
            bank_number: dataUpdate.bank_number,
          }),
        }
      };
      setLoading(true)
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false)
      if (checkDataOld) {
        if (type === "files" && selectedImage.length === 0) {
          let descriptionFileUpload = uploadDescriptions.length > 0
            ? "Bạn vui lòng tải lên ít nhất " + minFiles + " trong " + uploadDescriptions.length + " hình ảnh dưới để xác minh tài khoản<br/><br/>"
            : "Bạn vui lòng tải lên ít nhất " + minFiles + " hình ảnh để xác minh tài khoản<br/><br/>";
          uploadDescriptions.forEach((element, index) => {
            descriptionFileUpload += (index + 1) + ". " + element + "</br>";
          });
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload)
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        const verificationMatched =
          (type === "mail" && checkDataOld.submitEmail === 1) ||
          (type === "phone_number" && checkDataOld.submitPhoneNumber === 1);
        if (confirmUpdate || verificationMatched || type === "auto_confirm" || (timesCheckData >= 100 && checkDataOld.allowSubmit >0)) {
          confirmUpdateUser(body, type);
        } else {
          setLoading(false)
          Swal.fire({
            icon: "warning",
            title: "Chú ý",
            text: type === "mail"
              ? "Quý khách nhập không đúng Email đã liên kết, vui lòng kiểm tra lại hoặc sử dụng cách khác."
              : type === "phone_number"
                ? "Quý khách nhập không đúng Số Điện Thoại đã liên kết, vui lòng kiểm tra lại hoặc sử dụng cách khác."
                : "Thông tin xác thực chưa chính xác, vui lòng kiểm tra lại.",
            showCancelButton: true,
            cancelButtonText: 'Quay về chỉnh sửa',
            confirmButtonText: "Tiếp tục gửi",
            showConfirmButton: type === "files",
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed && type === "files") {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData((currentTimes) => currentTimes + 1);
              if (type === "mail" || type === "phone_number") modalConfirmUpdate(type, checkData);
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    navigate("/profile", { state: {userName, data: { ...data, recent_requests: recentRequests }, webSetting} });
  };

  const refreshSubmittedRequest = async () => {
    if (!submittedRequest?.request_code || isRefreshingRequest) return;
    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");
    const result = await apiGetRequestHistory(user.account, submittedRequest.request_code);
    setIsRefreshingRequest(false);
    if (result?.code === 200 && result?.data?.request) {
      const request = result.data.request;
      setSubmittedRequest(request);
      setRecentRequests((items) => items.map((item) => (item._request_code || item.request_code) === request.request_code
        ? { ...request, _request_code: request.request_code, request_code: `xxxxx${request.request_code.slice(-3)}` }
        : item).slice(0, 2));
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
    } else {
      setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    }
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest.request_code);
      setRequestRefreshMessage(`Đã sao chép: ${submittedRequest.request_code}`);
    } catch (error) {
      setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
    }
  };

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);

    const validFiles = files.filter((file) => {
      if (file.size > 30 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `${file.name} vượt quá giới hạn 30MB.`,
        });
        return false;
      }
      return true;
    });

    event.target.value = ""; // cho phép chọn lại cùng 1 file sau khi xóa

    // previews bây giờ là object { url, type }
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type,
    }));

    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);

    // convert base64 (nếu vẫn cần)
    const base64Files = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );

    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Files]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  const options = banks.map((bank) => ({
    value: bank.code,
    label: bank.name,
  }));

  const requestBankOptions = config.LIST_REQUEST_BANK.map((request) => ({
    value: request,
    label: request,
  }));

  const requestUsdtOptions = config.LIST_REQUEST_USDT.map((request) => ({
    value: request,
    label: request,
  }));

  const walletOptions = [
    { value: "TRC20", label: "USDT-TRC20" },
  ];
  
  return (
    <div className="container">
    {(loading) && (
      <Loading loading={loading}/>
    )}
      <motion.div
        className="app"
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
      >
        <Header isPageSearch={false} pageToAcction={"/profile"} data={ {userName, data, webSetting} }/>

        <div className="content">
          {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
              {/* <div className="info-current">
                <Collapsible open={false} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                  <InfoUser />
                </Collapsible>
              </div> */}
              <div className="confirm-info-old">
                <span className="modal-titlte">VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT</span>
                <div className="input-info-list">
                  {errors.name && <p className="error">{errors.name}</p>}
                  <div className="input-card">
                    <span className="input-label">Họ và Tên</span>
                    <input type="text" name="name" value={dataCheck.name} onChange={inputDataCheck} placeholder={data.Name} />
                  </div>
                  {/* <div className="input-card">
                    <span className="input-label">Ngân Hàng</span>
                    <input type="text" name="bank_name" value={dataCheck.bank_name || data.bank_name || ""} onChange={inputDataCheck} placeholder={data.bank_name || "Ngân hàng"} readOnly={!dataCheck.bank_name} />
                    {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                  </div> */}
                  {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                  <div className="input-card" style={{padding:0, paddingTop: "5px",paddingBottom: "5px"}}>
                    <span className="input-label" style={{paddingLeft: "10px"}}>Ngân Hàng</span>
                    <SelectSearch
                      className="select-search"
                      placeholder={data.bank_name}
                      options={options}
                      value={options.find((option) => option.value === dataCheck.bank_code) || null}
                      onChange={selectBankCheck}
                      styles={{
                        control: (base) => ({
                          ...base,
                          border: "none",
                          boxShadow: "none",
                          backgroundColor: "transparent",
                          color: "#003B52",
                          padding: "0",
                          margin: "0",
                          textAlign: "right",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          justifyContent: "flex-end",
                          padding: 0,
                        }),
                        input: (base) => ({
                          ...base,
                          color: "#003B52",
                          padding: "0",
                          textAlign: "right",
                        }),
                        singleValue: (base) => ({
                          ...base,
                          padding: "0",
                          color: "#003B52",
                          textAlign: "right",
                          marginLeft: "auto",
                        }),
                        placeholder: (base) => ({
                          ...base,
                          textAlign: "right",
                          marginLeft: "auto",
                        }),
                        menu: (base) => ({
                          ...base,
                          borderRadius: "8px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          marginTop: "4px",
                        }),
                        menuList: (base) => ({
                          ...base,
                          padding: "4px 0",
                        }),
                        option: (base, state) => ({
                          ...base,
                          textAlign: "left",
                          padding: "10px 15px",
                          backgroundColor: state.isSelected 
                            ? "#2F80ED" 
                            : state.isFocused 
                            ? "#E6F0FF" 
                            : "#FFFFFF",
                          color: state.isSelected ? "#FFFFFF" : "#003B52",
                          cursor: "pointer",
                          "&:active": {
                            backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                          },
                        }),
                      }}
                    />
                  </div>
                  {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                  <div className="input-card">
                    <span className="input-label">Số Tài Khoản</span>
                    <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder={data.bank_number} />
                  </div>
                  <textarea
                    name="note"
                    value={dataCheck.note}
                    onChange={inputDataCheck}
                    placeholder="Ghi chú khác nếu có"
                    rows={2}
                  />
                </div>
              </div>
              <div className="confirm-info-new">
                <span className="modal-titlte">THAY ĐỔI THÔNG TIN MỚI</span>
                {
                  {
                    "full_name": 
                    <div className="input-info-list">
                      {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                      <div className="input-card">
                        <span className="input-label">Họ Tên Mới</span>
                        <input type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                      </div>
                    </div>,
                    "phone_number": 
                    <div className="input-info-list">
                      {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                      <div className="input-card">
                        <span className="input-label">Số Điện Thoại Mới</span>
                        <input type="text" name="phone_number" onChange={inputDataUpdate}  placeholder="Số Điện Thoại Mới" />
                      </div>
                    </div>,
                    "email": 
                    <div className="input-info-list">
                      {errors.emailUpdate && <p className="error">{errors.emailUpdate}</p>}
                      <div className="input-card">
                        <span className="input-label">Email Mới</span>
                        <input type="text" name="email" onChange={inputDataUpdate} placeholder="Email Mới" />
                      </div>
                    </div>,
                    "bank": 
                    <div className="input-info-list">
                      {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                      <div className="input-card" style={{padding:0, paddingTop: "5px",paddingBottom: "5px"}}>
                        <span className="input-label" style={{paddingLeft: "10px"}}>Yêu cầu thay đổi</span>
                        <SelectSearch
                          className="select-search"
                          placeholder={"Chọn yêu cầu"}
                          options={requestBankOptions}
                          value={requestBankOptions.find(opt => opt.value === dataUpdate.bank_type_change)}
                          onChange={(selectedOption) =>
                            inputDataUpdate({ target: { name: "bank_type_change", value: selectedOption ? selectedOption.value : "" } })
                          }
                          styles={{
                            control: (base) => ({
                              ...base,
                              border: "none",
                              boxShadow: "none",
                              backgroundColor: "transparent",
                              color: "#003B52",
                              padding: "0",
                              margin: "0",
                              textAlign: "right",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              justifyContent: "flex-end",
                              padding: 0,
                            }),
                            input: (base) => ({
                              ...base,
                              color: "#003B52",
                              padding: "0",
                              textAlign: "right",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              padding: "0",
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: "8px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              marginTop: "4px",
                            }),
                            menuList: (base) => ({
                              ...base,
                              padding: "4px 0",
                            }),
                            option: (base, state) => ({
                              ...base,
                              textAlign: "left",
                              padding: "10px 15px",
                              backgroundColor: state.isSelected 
                                ? "#2F80ED" 
                                : state.isFocused 
                                ? "#E6F0FF" 
                                : "#FFFFFF",
                              color: state.isSelected ? "#FFFFFF" : "#003B52",
                              cursor: "pointer",
                              "&:active": {
                                backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                              },
                            }),
                          }}
                        />
                      </div>
                      {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                      <div className="input-card" style={{padding:0, paddingTop: "5px",paddingBottom: "5px"}}>
                        <span className="input-label" style={{paddingLeft: "10px"}}>{`Ngân Hàng ${bankFieldSuffix}`}</span>
                        <SelectSearch
                          className="select-search"
                          placeholder={`Chọn Ngân Hàng ${bankFieldSuffix}`}
                          options={options}
                          value={options.find((option) => option.value === dataUpdate.bank_code) || null}
                          onChange={selectBankUpdate}
                          styles={{
                            control: (base) => ({
                              ...base,
                              border: "none",
                              boxShadow: "none",
                              backgroundColor: "transparent",
                              color: "#003B52",
                              padding: "0",
                              margin: "0",
                              textAlign: "right",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              justifyContent: "flex-end",
                              padding: 0,
                            }),
                            input: (base) => ({
                              ...base,
                              color: "#003B52",
                              padding: "0",
                              textAlign: "right",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              padding: "0",
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: "8px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              marginTop: "4px",
                            }),
                            menuList: (base) => ({
                              ...base,
                              padding: "4px 0",
                            }),
                            option: (base, state) => ({
                              ...base,
                              textAlign: "left",
                              padding: "10px 15px",
                              backgroundColor: state.isSelected 
                                ? "#2F80ED" 
                                : state.isFocused 
                                ? "#E6F0FF" 
                                : "#FFFFFF",
                              color: state.isSelected ? "#FFFFFF" : "#003B52",
                              cursor: "pointer",
                              "&:active": {
                                backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                              },
                            }),
                          }}
                        />
                      </div>
                      {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                      <div className="input-card">
                        <span className="input-label">{`Số TK Ngân Hàng ${bankFieldSuffix}`}</span>
                        <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder="" />
                      </div>
                      {errors.full_name_bank && <p className="error">{errors.full_name_bank}</p>}
                      <div className="input-card">
                        <span className="input-label">Họ Và Tên</span>
                        <input type="text" name="full_name_bank" onChange={inputDataUpdate} placeholder="Họ Và Tên" />
                      </div>
                    </div>,
                    "birthday":
                    <div className="input-info-list">
                      {errors.birthDayUpdate && <p className="error">{errors.birthDayUpdate}</p>}
                      <div className="input-card">
                        <span className="input-label">Ngày tháng năm sinh</span>
                        <input type="date" name="birth_day" onChange={inputDataUpdate} placeholder="ngày tháng năm sinh" defaultValue="2000-12-01"/>
                      </div>
                    </div>,
                    "usdt":
                    <div className="input-info-list">
                      {errors.bankTypeChange && <p className="error">{errors.bankTypeChange}</p>}
                      <div className="input-card" style={{padding:0, paddingTop: "5px",paddingBottom: "5px"}}>
                        <span className="input-label" style={{paddingLeft: "10px"}}>Yêu cầu thay đổi</span>
                        <SelectSearch
                          className="select-search"
                          placeholder={"Chọn yêu cầu"}
                          options={requestUsdtOptions}
                          value={requestUsdtOptions.find(opt => opt.value === dataUpdate.bank_type_change)}
                          onChange={(selectedOption) =>
                            inputDataUpdate({ target: { name: "bank_type_change", value: selectedOption ? selectedOption.value : "" } })
                          }
                          styles={{
                            control: (base) => ({
                              ...base,
                              border: "none",
                              boxShadow: "none",
                              backgroundColor: "transparent",
                              color: "#003B52",
                              padding: "0",
                              margin: "0",
                              textAlign: "right",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              justifyContent: "flex-end",
                              padding: 0,
                            }),
                            input: (base) => ({
                              ...base,
                              color: "#003B52",
                              padding: "0",
                              textAlign: "right",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              padding: "0",
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: "8px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              marginTop: "4px",
                            }),
                            menuList: (base) => ({
                              ...base,
                              padding: "4px 0",
                            }),
                            option: (base, state) => ({
                              ...base,
                              textAlign: "left",
                              padding: "10px 15px",
                              backgroundColor: state.isSelected 
                                ? "#2F80ED" 
                                : state.isFocused 
                                ? "#E6F0FF" 
                                : "#FFFFFF",
                              color: state.isSelected ? "#FFFFFF" : "#003B52",
                              cursor: "pointer",
                              "&:active": {
                                backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                              },
                            }),
                          }}
                        />
                      </div>
                      
                      {errors.walletName && <p className="error">{errors.walletName}</p>}
                      <div className="input-card" style={{padding:0, paddingTop: "5px",paddingBottom: "5px"}}>
                        <span className="input-label" style={{paddingLeft: "10px"}}>Chọn Ví Mới</span>
                        <SelectSearch
                          className="select-search"
                          placeholder={"Chọn Ví Mới"}
                          options={walletOptions}
                          value={walletOptions.find(opt => opt.value === dataUpdate.wallet_name)}
                          onChange={(selectedOption) =>
                            inputDataUpdate({ target: { name: "wallet_name", value: selectedOption ? selectedOption.value : "" } })
                          }
                          styles={{
                            control: (base) => ({
                              ...base,
                              border: "none",
                              boxShadow: "none",
                              backgroundColor: "transparent",
                              color: "#003B52",
                              padding: "0",
                              margin: "0",
                              textAlign: "right",
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              justifyContent: "flex-end",
                              padding: 0,
                            }),
                            input: (base) => ({
                              ...base,
                              color: "#003B52",
                              padding: "0",
                              textAlign: "right",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              padding: "0",
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: "#003B52",
                              textAlign: "right",
                              marginLeft: "auto",
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: "8px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                              marginTop: "4px",
                            }),
                            menuList: (base) => ({
                              ...base,
                              padding: "4px 0",
                            }),
                            option: (base, state) => ({
                              ...base,
                              textAlign: "left",
                              padding: "10px 15px",
                              backgroundColor: state.isSelected 
                                ? "#2F80ED" 
                                : state.isFocused 
                                ? "#E6F0FF" 
                                : "#FFFFFF",
                              color: state.isSelected ? "#FFFFFF" : "#003B52",
                              cursor: "pointer",
                              "&:active": {
                                backgroundColor: state.isSelected ? "#2F80ED" : "#E6F0FF",
                              },
                            }),
                          }}
                        />
                      </div>
                      
                      {errors.walletNumber && <p className="error">{errors.walletNumber}</p>}
                      <div className="input-card">
                        <span className="input-label">Số Ví USDT Mới</span>
                        <input type="text" name="wallet_number" onChange={inputDataUpdate} placeholder="Số Ví USDT Mới" />
                      </div>
                    </div>,
                  }[typeModal]
                }
              </div>
              <div className="mode-verify">
                <span className="modal-titlte">VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC</span>
                {(typeModal !== "birthday" ) &&
                <>
                  <div className="action action-verify">
                    { data.email &&
                    <button onClick={() => modalConfirmUpdate("mail")} className="action-verify-btn">
                      <img src={iconSendMail} alt="icon-bank" />
                      &nbsp; GỬI QUA EMAIL
                    </button>
                    }
                    { data.phone_number &&
                    <button onClick={() => modalConfirmUpdate("phone_number")} className="action-verify-btn">
                      <img src={iconSendPhone} alt="icon-bank" />
                      &nbsp; GỬI QUA SĐT
                    </button>
                    }
                  </div>
                  <p className='note-verify-image'>
                    Nếu quý khách không có email hoặc SDT để gửi thông tin, vui lòng nhấn nút dưới đây để thực hiện thay thế
                  </p>
                </>
                }
                <div className="action action-verify">
                  <button id="confirm_files_btn" onClick={() => modalConfirmUpdate("files")}>
                  <img src={iconImage} alt="icon-bank" />
                    &nbsp;&emsp; TẢI LÊN HÌNH ẢNH THAY THẾ XÁC THỰC
                  </button>
                </div>
                {canAutoConfirm && (
                  <div className="action action-verify">
                    <button type="button" onClick={() => modalConfirmUpdate("auto_confirm")} className="action-verify-btn" disabled={loading}>
                      XÁC NHẬN HOÀN THÀNH
                    </button>
                  </div>
                )}
              </div>
            </motion.div>
          {/* </Popup> */}
          <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center" }} contentStyle={{ position: "relative", inset: "auto" }}>
            <motion.div
              initial={{ opacity: 0, y: 75 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              id="modal-confirm"
              className="modal-confirm"
            >
              <div className="modal-close">
                <button type="button" className="icon-close" onClick={closeModalConfirm} style={{ background: "none", border: "none", cursor: "pointer" }}>
                  <img src={iconClose} alt="icon-close" />
                </button>
              </div>
              <div className="modal-confirm-content">
                <img className="icon-warning" src={iconWarning} alt="icon-warning" />
                {isSendMail ? (
                  <p>
                    Vui lòng sử dụng email đã liên kết <span style={{ color: "green" }}>{dataCheck.email}</span> gửi thư tới email Jun88{" "}
                    <span style={{ color: "red" }}>{ webSetting.email }</span>, với nội dung:
                  </p>
                ) : user.send_type === 'phone_number' ? (
                  <p>
                    Vui lòng sử dụng số điện thoại đã liên kết <span style={{ color: "green" }}>{dataCheck.phone_number}</span> gửi tin nhắn tới số điện thoại Jun88{" "}
                    <span style={{ color: "red" }}>{ webSetting.phone_number }</span>, với nội dung:
                  </p>
                ) : (
                  <p>
                    Yêu cầu của quý khách đã được tiếp nhận. Vui lòng lưu lại mã yêu cầu để tra cứu lịch sử xét duyệt khi cần.
                  </p>
                )}
                <DataConfirm user={user} webSetting={webSetting} />
                {submittedRequest && <div className={`request-processing-status status-${submittedRequest.status} request-verification-${["email", "phone_number"].includes(submittedRequest.send_type) ? submittedRequest.verification_status || "not_received" : "success"}`}>
                {submittedRequest.status === "no_process" && <div className={`request-live-update-notice ${pollingCount >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                  {pollingCount < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                  <div>
                    <strong>{pollingCount < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : "Đã hoàn tất kiểm tra tự động"}</strong>
                    <small>{pollingCount < 15 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                  </div>
                </div>}
                <strong className="request-processing-title">{submittedRequest.status === "approved"
                  ? "Yêu cầu đã được xử lý thành công"
                  : submittedRequest.status === "removed"
                    ? "Yêu cầu đã bị từ chối"
                    : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success"
                      ? "Yêu cầu đang chờ xác thực"
                      : pollingCount < 15
                        ? "Yêu cầu đang được xử lý"
                        : "Yêu cầu đang được xử lý lâu hơn dự kiến"}</strong>
                {(submittedRequest.note || submittedRequest.result) && <div className="request-result-note"><strong>Kết quả xử lý:</strong><HtmlNote html={submittedRequest.note || submittedRequest.result} /></div>}
                <div className="request-progress">
                  <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                  <div className={`request-progress-step ${!["email", "phone_number"].includes(submittedRequest.send_type) || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}><span>2</span><small>{["email", "phone_number"].includes(submittedRequest.send_type) ? "Xác thực" : "Đã tiếp nhận"}</small></div>
                  <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}><span>3</span><small>Đang xử lý</small></div>
                  <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}><span>4</span><small>Hoàn tất</small></div>
                </div>
                {submittedRequest.status === "no_process" && <div className="request-processing-message">
                  {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi email bằng địa chỉ đã liên kết.</p>}
                  {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi SMS bằng số điện thoại đã liên kết.</p>}
                  {submittedRequest.verification_status === "invalid" && <p>Xác thực không hợp lệ. Vui lòng kiểm tra email/số điện thoại và gửi lại.</p>}
                  {pollingCount >= 15 && <p>Yêu cầu đang xử lý lâu hơn dự kiến.</p>}
                </div>}
                {submittedRequest.status === "no_process" && pollingCount >= 15 && <div className="request-processing-actions">
                  <button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button>
                  <button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button>
                  <a href={webSetting?.link_cskh} target="_blank" rel="noopener noreferrer">Liên hệ CSKH</a>
                </div>}
                {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
              </div>}
                <div className="notification request-support-note">
                  <p>- Liên hệ <a href={webSetting.link_cskh} target="_blank" rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                </div>
              </div>
            </motion.div>
          </Popup>
          <Popup open={openUploadFile} onClose={() => setOpenUploadFile(false)} position={"center"}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="modal-success"
            >
              <div className="modal-close">
                <button type="button" className="icon-close" onClick={() => setOpenUploadFile(false)} style={{ background: "none", border: "none", cursor: "pointer" }}>
                  <img src={iconClose} alt="icon-close" />
                </button>
              </div>
              <div className="modal-result-content">
                <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                <span>Bạn cần cung cấp thêm hình ảnh để xác minh thông tin.</span>

                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    color: "black",
                    marginBottom: "-10px",
                    marginTop: "-15px",
                    fontWeight: "bold",
                  }}
                >
                  <div className="upload-file" dangerouslySetInnerHTML={{ __html: infoFileUpload }} />
                </Typography>

                <Box display="flex" alignItems="center" marginY={1} flexWrap="wrap" gap="8px 8px">
                  {previews.map((preview, index) => (
                    <Box
                      onClick={() => handleRemoveImage(index)}
                      key={index}
                      sx={{
                        maxHeight: 80,
                        maxWidth: 90,
                        width: "auto",
                        height: "auto",
                        position: "relative",
                        overflow: "hidden",
                        cursor: "pointer",
                        "&:hover .delete-button": {
                          display: "block",
                        },
                      }}
                    >
                      {preview.type.startsWith("image/") ? (
                        <img
                          src={preview.url}
                          alt={`preview-${index}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                        />
                      ) : (
                        <video
                          src={preview.url}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                          controls
                        />
                      )}

                      <IconButton
                        className="delete-button"
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          color: "red",
                          p: 0,
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}

                  <Box>
                    <input
                      accept="image/*,video/*"
                      style={{ display: "none" }}
                      id="upload-button"
                      type="file"
                      onChange={handleImageUpload}
                      multiple
                    />
                    <label htmlFor="upload-button">
                      <Button
                        variant="outlined"
                        component="span"
                        startIcon={<AddPhotoAlternateOutlined sx={{ fontSize: "large" }} />}
                        sx={{
                          width: "90px",
                          height: "80px",
                          color: "#6BB0C8",
                          borderColor: "#6BB0C8",
                          borderStyle: "solid",
                          "&:hover": {
                            borderColor: "#6BB0C8",
                            color: "#6BB0C8",
                          },
                        }}
                      >
                        Thêm
                      </Button>
                    </label>
                  </Box>
                </Box>

                <Typography variant="caption" sx={{ color: "#B0B3C1" }}>
                  Cung cấp hình ảnh đúng theo mô tả để được xét duyệt
                </Typography>

                {selectedImage.length >= minFiles && (
                  <div>
                    <button
                      id="complete_files_btn"
                      onClick={() => {
                        setOpenUploadFile(false);
                        updateUser(user.send_type);
                      }}
                    >
                      Hoàn thành xác minh
                    </button>
                  </div>
                )}
              </div>
            </motion.div>
          </Popup>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
